import React from 'react'
import Window from '@/components/ui/window'

type Props = {
  id?: string;
}

const Orders: React.FC<Props> = (): JSX.Element => {

return ( 
    <Window content={<><div>how are you.</div></>}  key='order' title='Pending Orders'/>
)
}

export default Orders